export const CREATE_HOUSINGRESULT_ERROR = 'CREATE_HOUSINGRESULT_ERROR';
export const CREATE_HOUSINGRESULT_SUCCESS = 'CREATE_HOUSINGRESULT_SUCCESS';

export const DELETE_HOUSINGRESULT_ERROR = 'DELETE_HOUSINGRESULT_ERROR';
export const DELETE_HOUSINGRESULT_SUCCESS = 'DELETE_HOUSINGRESULT_SUCCESS';


export const UPDATE_HOUSINGRESULT_ERROR = 'UPDATE_HOUSINGRESULT_ERROR';
export const UPDATE_HOUSINGRESULT_SUCCESS = 'UPDATE_HOUSINGRESULT_SUCCESS';

export const LOAD_HOUSINGRESULTS_SUCCESS = 'LOAD_HOUSINGRESULTS_SUCCESS';
export const UNLOAD_HOUSINGRESULTS_SUCCESS = 'UNLOAD_HOUSINGRESULTS_SUCCESS';


// WEBPACK FOOTER //
// ./src/core/housing-result/action-types.js